import React, { useEffect, useState, useRef } from "react";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import Top from "../Top";
import { API_URL } from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GoDeviceDistributors from "../godevice/GoDeviceDistributors";
import GoDeviceDistributors6 from "../godevice/GoDeviceDistributors6";
import GodeviceOwnerAccordian5 from "../godevice/GodeviceOwnerAccordian5";
import GoDeviceOwner from "../godevice/GoDeviceOWner";
import GoDeviceOwner6 from "../godevice/GoDeviceOwner6";
import GoDeviceOwnerAcc6 from "../godevice/GoDeviceOwnerAcc6";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const CustomerPage = () => {
  const classes = useStyles();
  const [distId, setDistId] = useState(null);
  const navigation = useNavigate();
  const location = useLocation();
  const [customerDeviceModal, setCustomerDeviceModal] = useState(false);
  const [firstName1, setFirstName1] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [passShow, setPassShow] = useState(false);
  const [password1, setPassword1] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [age, setAge] = useState("");
  const [country, setCountry] = useState("");
  const [gender, setGender] = useState("");
  const [business, setBusiness] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [countryId, setCountryId] = useState("");
  const [state, setState] = useState("");
  const [stateId, setStateId] = useState("");
  const [ownerId, setOwnerId] = useState(null);
  const [fetchdata, setFetchdata] = useState(true);
  const [dataload, setDataload] = useState(false);

  const CustomerDeviceToggleModal = () => {
    setCustomerDeviceModal(!customerDeviceModal);
    if (passShow) {
      setPassShow(!passShow);
    }
  };

  const dist = new URLSearchParams(window.location.search).get("dist");
  const profile_status = new URLSearchParams(window.location.search).get(
    "profile_status"
  );
  const deviceType = new URLSearchParams(window.location.search).get(
    "device_type"
  );

  const [data, setData] = useState([]);

  const [distList, setDistList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);

  const userid = localStorage.getItem("user_id");
  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    handleDistList();
    godevicelist();
  }, [dist, profile_status, deviceType]);

  const handleCustomerView = (event) => {
    setDataload(true);
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setPostalCode("");
    setCountryId("");
    setState("");
    setBusiness("");
    setAge("");
    setGender("");
    setDistId(event);
    setOwnerId(event);
    let url = `/get/owner/device/by/${event}`;
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname == null ? "NA" : item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(
              item.address == null || item.address.length == 0
                ? "NA"
                : item.address
            );
            setAddress2(item.address2 == null ? "NA" : item.address2);
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            if (item.city == null || item.city == "") {
              setCity("NA");
            } else {
              setCity(item.city);
            }
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
            setBusiness(item.business == null ? "NA" : item.business);
            setStateId(item.state == null ? "NA" : item.state);
            setPostalCode(item.zipcode == null ? "NA" : item.zipcode);
            getCountry(item.country);
            getState(item.country, item.state);
          });
          setDataload(false);
        });
      } else if (response.status == 422) {
        setFirstName1("NA");
        setLastName("NA");
        setPassword1("NA");
        setEmail("NA");
        setBusiness("NA");
        setAddress1("NA");
        setAddress2("NA");
        setPostalCode("NA");
        setTelephone1("NA");
        setCity("NA");
        setCountry("NA");
        setState("NA");
        setAge("NA");
        setGender("NA");
        setDataload(false);
      } else if (response.status == 400) {
        alert("Network error");
      }
    });
  };

  const godevicelist = () => {
    setData([]);
    let type = localStorage.getItem("user_type");
    let id = localStorage.getItem("user_id");

    let url = "/get/seven/customer/details";
    if (type == 6) {
      let _url = "/get/seven/customer/details";
      const params = { distributer: id };
      const queryString = new URLSearchParams(params).toString();
      url = `${_url}?${queryString}`;
    } else if (type == 7 || type == 8) {
      if (dist) {
        if (dist == "all" && !deviceType && !profile_status) {
          url = "/get/seven/customer/details";
        } else if (dist == "all" && !deviceType && profile_status) {
          let _url = "/get/seven/customer/details";
          const params = { profile_status: profile_status };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else if (dist == "all" && deviceType && profile_status) {
          if (deviceType == "all" && profile_status != "all") {
            let _url = "/get/seven/customer/details";
            const params = { profile_status: profile_status };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (profile_status == "all") {
            url = "/get/seven/customer/details";
          } else {
            let _url = "/get/seven/customer/details";
            const params = {
              device_type: deviceType,
              profile_status: profile_status,
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (dist == "all" && deviceType && deviceType != "all") {
          let _url = "/get/seven/customer/details";
          const params = { device_type: deviceType };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else if (dist && deviceType) {
          if (dist == "all" && deviceType == "all") {
            url = `/get/seven/customer/details`;
          } else if (
            dist != "all" &&
            deviceType != "all" &&
            deviceType != "8" &&
            deviceType != "9" &&
            !profile_status
          ) {
            let _url = "/get/seven/customer/details";
            //module (c) and (m) not
            const params = { distributer: dist, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist != "all" &&
            deviceType != "all" &&
            deviceType != "8" &&
            deviceType != "9" &&
            profile_status
          ) {
            if (profile_status == "all") {
              let _url = "/get/seven/customer/details";
              //module (c) and (m) not
              const params = { distributer: dist, device_type: deviceType };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else {
              let _url = "/get/seven/customer/details";
              //module (c) and (m) not
              const params = {
                distributer: dist,
                device_type: deviceType,
                profile_status: profile_status,
              };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            }
          } else if (
            dist != "all" &&
            deviceType != "all" &&
            deviceType == "8" &&
            deviceType != "9" &&
            !profile_status
          ) {
            // module (m)
            let _url = "/get/seven/customer/details";
            const params = {
              distributer: dist,
              device_type: "5",
              m_module: "1",
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist != "all" &&
            deviceType != "all" &&
            deviceType == "8" &&
            deviceType != "9" &&
            profile_status
          ) {
            // module (m)
            let _url = "/get/seven/customer/details";
            const params = {
              distributer: dist,
              device_type: "5",
              m_module: "1",
              profile_status: profile_status,
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist != "all" &&
            deviceType != "all" &&
            deviceType != "8" &&
            deviceType == "9" &&
            !profile_status
          ) {
            let _url = "/get/seven/customer/details";
            //module (c)
            const params = {
              distributer: dist,
              device_type: "5",
              c_module: "1",
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist != "all" &&
            deviceType != "all" &&
            deviceType != "8" &&
            deviceType == "9" &&
            profile_status
          ) {
            if (profile_status == "all") {
              let _url = "/get/seven/customer/details";
              //module (c)
              const params = {
                distributer: dist,
                device_type: "5",
                c_module: "1",
              };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else {
              let _url = "/get/seven/customer/details";
              //module (c)
              const params = {
                distributer: dist,
                device_type: "5",
                c_module: "1",
                profile_status: profile_status,
              };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            }
          } else if (dist != "all" && deviceType == "all" && !profile_status) {
            let _url = "/get/seven/customer/details";
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist != "all" && deviceType == "all" && profile_status) {
            if (profile_status == "all") {
              let _url = "/get/seven/customer/details";
              const params = { distributer: dist };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else {
              let _url = "/get/seven/customer/details";
              const params = {
                distributer: dist,
                profile_status: profile_status,
              };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            }
          } else if (dist == "all" && deviceType != "all") {
            let _url = "/get/seven/customer/details";
            const params = { device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/seven/customer/details";
            const params = { device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (dist != "all" && deviceType) {
          if (deviceType == "all") {
            let _url = "/get/seven/customer/details";
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/seven/customer/details";
            const params = { distributer: dist, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (dist == "all" && !deviceType) {
          url = "/get/seven/customer/details";
        } else if (dist != "all" && !deviceType && profile_status) {
          if (profile_status == "all") {
            let _url = "/get/seven/customer/details";
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/seven/customer/details";
            const params = {
              distributer: dist,
              profile_status: profile_status,
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (dist != "all" && deviceType && profile_status) {
          let _url = "/get/seven/customer/details";
          const params = {
            distributer: dist,
            device_type: deviceType,
            profile_status: profile_status,
          };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else {
          let _url = "/get/seven/customer/details";
          const params = { distributer: dist };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        }
      } else if (dist == 0) {
        let _url = "/get/seven/customer/details/profile";
        const params = { type: dist };
        const queryString = new URLSearchParams(params).toString();
        url = `${_url}?${queryString}`;
      } else if (dist == 1) {
        let _url = "/get/seven/customer/details/profile";
        const params = { type: dist };
        const queryString = new URLSearchParams(params).toString();
        url = `${_url}?${queryString}`;
      } else if (deviceType) {
        if (deviceType == "all" && !dist) {
          url = "/get/seven/customer/details";
        } else {
          let _url = "/get/seven/customer/details";
          const params = { device_type: deviceType };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        }
      }
    }
    // ============================implementing filter============
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          resp.data.map((v, i) => {
            _temp.push({
              firstname:
                v.email == null && v.firstname == null
                  ? "Not Registered"
                  : v.firstname == null
                  ? "Profile Incomplete"
                  : v.firstname + " " + v.lastname,
              ownerfirstname:
                v.ownerlastname == null && v.ownerfirstname == null
                  ? "Profile Incomplete"
                  : v.ownerfirstname + " " + v.ownerlastname,
              devicetype:
                v.device_type == "5"
                  ? "GO Personal" +
                    (v.c_module == 1 ? "(C)" : "") +
                    (v.m_module == 1 ? "(M)" : "")
                  : v.device_type == 6
                  ? "GO Basic"
                  : v.device_type == 7
                  ? "GO Professional"
                  : "No device type",
              email: v.email == null ? "NA" : v.email,
              status:
                v.status == null ? "NA" : v.status == 1 ? "Active" : "Inactive",
              profileStatus:
                v.complete == null
                  ? "NA"
                  : v.complete == 1
                  ? "Complete"
                  : "Incomplete",
              telephone:
                v.telephone == null || v.telephone.length == 0
                  ? "NA"
                  : v.telephone,

              action: (
                <ul className="action-list">
                  <li>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="View"
                      placement="top"
                    >
                      <a
                        href="javascript:void(0)"
                        onClick={() => {
                          handleCustomerView(v.eid);
                          setCustomerDeviceModal(!customerDeviceModal);
                        }}
                        className="view-patient"
                      >
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      </a>
                    </Tooltip>
                  </li>
                </ul>
              ),
            });
          });
          _temp.sort((a, b) => {
            const DnameA = a.firstname.toLowerCase();
            const DnameB = b.firstname.toLowerCase();
            const CnameA = a.ownerfirstname.toLowerCase();
            const CnameB = b.ownerfirstname.toLowerCase();
            if (DnameA == DnameB) {
              if (CnameA < CnameB) {
                return -1;
              } else if (CnameA > CnameB) {
                return 1;
              } else {
                return 0;
              }
            } else {
              if (DnameA < DnameB) {
                return -1;
              } else if (DnameA > DnameB) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          setFetchdata(false);
          setData(_temp);
        });
      }
    });
  };
  const handleDistList = () => {
    let url = `/get/distributor/seven`;
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDistList(resp.data);
        });
      }
    });
  };
  const columns = [
    {
      title: "Distributor",
      field: "firstname",
      cellStyle: {
        textTransform: "capitalize",
      },
      customSort: (a, b) => {
        const customerA = a.firstname || a.email || ""; // Handle null or empty values
        const customerB = b.firstname || b.email || ""; // Handle null or empty values
        return customerA.localeCompare(customerB);
      },
    },
    {
      title: "Customer",
      field: "ownerfirstname",
      cellStyle: {
        textTransform: "capitalize",
      },
      customSort: (a, b) => {
        const customerA = a.ownerfirstname || a.email || ""; // Handle null or empty values
        const customerB = b.ownerfirstname || b.email || ""; // Handle null or empty values
        return customerA.localeCompare(customerB);
      },
    },
    {
      title: "Email",
      field: "email",
      customSort: (a, b) => {
        const customerA = a.email || a.email || ""; // Handle null or empty values
        const customerB = b.email || b.email || ""; // Handle null or empty values
        return customerA.localeCompare(customerB);
      },
    },

    {
      title: "Status",
      field: "status",
    },
    {
      title: "Profile Status",
      field: "profileStatus",
    },

    {
      title: "Telephone",
      field: "telephone",
    },
    {
      title: "Device Type",
      field: "devicetype",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
      alignItem: "right",
    },
  ];
  const handleGoBack = () => {
    navigation("/customers");
  };
  const handleDistributorChange = (event) => {
    const params = new URLSearchParams(window.location.search);
    if (
      event == "all" &&
      params != 0 &&
      window.location.href.includes("dist=")
    ) {
      const oldValue = new URLSearchParams(window.location.search).get("dist");
      const newValue = event;
      const newUrl = window.location.search.replace(
        `dist=${oldValue}`,
        `dist=${newValue}`
      );
      navigation(`${location.pathname}` + `${newUrl}`);
    } else {
      if (window.location.href.includes("dist=")) {
        const oldValue = new URLSearchParams(window.location.search).get(
          "dist"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `dist=${oldValue}`,
          `dist=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        const params = new URLSearchParams(window.location.search);
        if (params != 0) {
          navigation(
            `${location.pathname}` + "?" + `${params}` + "&dist=" + `${event}`
          );
        } else {
          navigation(`${location.pathname}` + "?dist=" + `${event}`);
        }
      }
    }
  };
  const handleDeviceTypeChange = (event) => {
    const params = new URLSearchParams(window.location.search);
    if (
      event == "all" &&
      params != 0 &&
      window.location.href.includes("device_type")
    ) {
      const oldValue = new URLSearchParams(window.location.search).get(
        "device_type"
      );
      const newValue = event;
      const newUrl = window.location.search.replace(
        `device_type=${oldValue}`,
        `device_type=${newValue}`
      );
      navigation(`${location.pathname}` + `${newUrl}`);
    } else {
      if (window.location.href.includes("device_type")) {
        const oldValue = new URLSearchParams(window.location.search).get(
          "device_type"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `device_type=${oldValue}`,
          `device_type=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        const params = new URLSearchParams(window.location.search);
        if (params != 0) {
          navigation(
            `${location.pathname}` +
              "?" +
              `${params}` +
              "&device_type=" +
              `${event}`
          );
        } else {
          navigation(`${location.pathname}` + "?device_type=" + `${event}`);
        }
      }
    }
  };
  const handleProfileStatus = (event) => {
    const params = new URLSearchParams(window.location.search);
    if (
      event == "all" &&
      params != 0 &&
      window.location.href.includes("profile_status")
    ) {
      const oldValue = new URLSearchParams(window.location.search).get(
        "profile_status"
      );
      const newValue = event;
      const newUrl = window.location.search.replace(
        `profile_status=${oldValue}`,
        `profile_status=${newValue}`
      );
      navigation(`${location.pathname}` + `${newUrl}`);
    } else {
      if (window.location.href.includes("profile_status")) {
        const oldValue = new URLSearchParams(window.location.search).get(
          "profile_status"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `profile_status=${oldValue}`,
          `profile_status=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        const params = new URLSearchParams(window.location.search);
        if (params != 0) {
          navigation(
            `${location.pathname}` +
              "?" +
              `${params}` +
              "&profile_status=" +
              `${event}`
          );
        } else {
          navigation(`${location.pathname}` + "?profile_status=" + `${event}`);
        }
      }
    }
  };

  const getCountry = (countryid) => {
    setCountry("");
    if (countryid == "" || countryid == null) {
      setCountry("NA");
    } else {
      fetch(API_URL + "/countries", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            resp.countries.map((item) => {
              if (item.id == countryid) {
                setCountry(item.name == null ? "NA" : item.name);
              }
            });
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      });
    }
  };

  const getState = (countryid, stateid) => {
    setState("");
    if (countryid == "" || stateid == null) {
      if (stateid == null || stateid == "") {
        setState("NA");
      } else if (stateid.includes("Choose States/Province")) {
        setState("NA");
      } else {
        setState(stateid);
      }
    } else {
      fetch(API_URL + "/states?country_id=" + countryid, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            resp.states.map((item) => {
              if (item.id == stateid) {
                setState(item.name);
              }
            });
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      });
    }
  };
  const handleShowPassword = () => {
    setPassShow(!passShow);
  };

  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="head-listing">
              <h3>Device GO Customers</h3>
              {user_type == 7 || user_type == 8 ? (
                <div
                  className="select-main-div"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="select-div">
                    <label>Filter By Distributor</label>
                    <select
                      className="select-tag"
                      onChange={(e) => handleDistributorChange(e.target.value)}
                    >
                      <option value="all">All</option>

                      {distList.length > 0 &&
                        distList?.map((item) => {
                          if (
                            item.firstname == "" ||
                            item.lastname == "" ||
                            item.firstname == null ||
                            item.lastname == null
                          ) {
                          } else {
                            return (
                              <option
                                value={item.eid}
                                selected={item.eid == dist ? "selecetd" : ""}
                              >
                                {item.firstname} {item.lastname}
                              </option>
                            );
                          }
                        })}
                    </select>
                  </div>
                  <div
                    className="select-div"
                    style={{ width: "100px !important" }}
                  >
                    <label>Filter By Device type</label>
                    <select
                      className="select-tag"
                      onChange={(e) => handleDeviceTypeChange(e.target.value)}
                      style={{ width: "100px !important" }}
                    >
                      <option value="all">All</option>
                      <option
                        value="5"
                        selected={deviceType == 5 ? "selecetd" : ""}
                      >
                        GO Personal
                      </option>
                      <option
                        value="8"
                        selected={deviceType == 8 ? "selecetd" : ""}
                      >
                        GO Personal(M)
                      </option>
                      <option
                        value="9"
                        selected={deviceType == 9 ? "selecetd" : ""}
                      >
                        GO Personal(C)
                      </option>
                      <option
                        value="6"
                        selected={deviceType == 6 ? "selecetd" : ""}
                      >
                        GO Basic
                      </option>
                      <option
                        value="7"
                        selected={deviceType == 7 ? "selecetd" : ""}
                      >
                        GO Professional
                      </option>
                    </select>
                  </div>
                  <div
                    className="select-div"
                    style={{ width: "100px !important" }}
                  >
                    <label>Profile Status</label>
                    <select
                      className="select-tag"
                      onChange={(e) => handleProfileStatus(e.target.value)}
                      style={{ width: "100px !important" }}
                    >
                      <option value="all">All</option>
                      <option
                        value="1"
                        selected={profile_status == 1 ? "selected" : ""}
                      >
                        Complete
                      </option>
                      <option
                        value="0"
                        selected={profile_status == 0 ? "selected" : ""}
                      >
                        Incomplete
                      </option>
                    </select>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="add-btn">
              <button onClick={handleGoBack}>Go Back</button>
            </div>
          </div>
          <Modal
            isOpen={customerDeviceModal}
            toggle={CustomerDeviceToggleModal}
            className="connect-box1"
            centered={true}
          >
            <ModalHeader toggle={CustomerDeviceToggleModal}>
              Customer Profile
            </ModalHeader>
            {dataload ? (
              <div className="loader12"></div>
            ) : (
              <div
                style={{
                  borderBottom: "1px solid #212529",
                  paddingBottom: "40px",
                }}
              >
                <div className="row-main" style={{ padding: "0 15px" }}>
                  <div className="row pt-3">
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <div>
                        <div>
                          <div className="modal_p">
                            <p className="font14 heading_p"> First Name : </p>
                            <p className="font14">{firstName1} </p>
                          </div>
                          <div className="modal_p">
                            <p className="font14 heading_p"> Last Name : </p>
                            <p className="font14">{lastName}</p>
                          </div>

                          <div className="modal_p">
                            <p className="font14 heading_p"> Email : </p>
                            <p className="font14 add_p">
                              {email != "NA" ? email : "NA"}
                            </p>
                          </div>
                          {localStorage.getItem("user_type") == 7 && (
                            <div className="modal_p">
                              <p className="font14 heading_p"> Password : </p>
                              {password1 != "NA" ? (
                                <p
                                  className="font14"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "35px",
                                  }}
                                >
                                  {passShow ? (
                                    password1
                                  ) : (
                                    <div style={{ display: "flex" }}>
                                      {[...Array(password1.length)].map(
                                        (_, index) => (
                                          <div key={index} className="ball" />
                                        )
                                      )}
                                    </div>
                                  )}
                                  <i
                                    className={
                                      passShow
                                        ? "fa-solid fa-eye eyeColor"
                                        : "fa-solid fa-eye-slash eyeColor"
                                    }
                                    onClick={handleShowPassword}
                                  ></i>
                                </p>
                              ) : (
                                <p
                                  className="font14"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "35px",
                                  }}
                                >
                                  {password1}
                                </p>
                              )}
                            </div>
                          )}
                          <div className="modal_p">
                            <p className="font14 heading_p"> Telephone : </p>
                            {/* <p className='font14'>{telephone1.length == 0 ? "NA" : telephone1}</p> */}
                            <p className="font14">
                              {telephone1 != "NA" ? telephone1 : "NA"}
                            </p>
                          </div>
                          {user_type != 8 && (
                            <div className="modal_p">
                              <p className="font14 heading_p"> Age : </p>
                              <p className="font14"> {age} </p>
                            </div>
                          )}
                          {user_type != 8 && (
                            <div className="modal_p">
                              <p className="font14 heading_p">
                                {" "}
                                Name of Business :{" "}
                              </p>
                              <p className="font14 add_p">
                                {" "}
                                {business.length == 0 ? "NA" : business}
                              </p>
                            </div>
                          )}
                        </div>
                        <div></div>
                      </div>
                    </div>
                    {user_type == 8 ? (
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div className="modal_p">
                          <p className="font14 heading_p"> Gender : </p>
                          <p className="font14"> {gender}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Country : </p>
                          <p className="font14">{country}</p>
                        </div>
                      </div>
                    ) : (
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div>
                          <div>
                            <div className="modal_p">
                              <p className="font14 heading_p"> City : </p>
                              <p className="font14">{city}</p>
                            </div>
                            <div className="modal_p">
                              <p className="font14 heading_p">
                                {" "}
                                Postal Code :{" "}
                              </p>
                              <p className="font14">
                                {postalCode.length == 0 ? "NA" : postalCode}
                              </p>
                            </div>
                            <div className="modal_p">
                              <p className="font14 heading_p"> Gender : </p>
                              <p className="font14"> {gender}</p>
                            </div>
                            <div className="modal_p">
                              <p className="font14 heading_p"> Country : </p>
                              <p className="font14">{country}</p>
                            </div>

                            <div className="modal_p ">
                              <p className="font14 heading_p"> State : </p>
                              <p className="font14">
                                {" "}
                                {state.length == 0 ? "NA" : state}
                              </p>
                            </div>
                            <div className="modal_p">
                              <p className="font14 heading_p"> Address 1 :</p>
                              <p className="font14 add_p">{address1}</p>
                            </div>
                            <div className="modal_p">
                              <p className="font14 heading_p"> Address 2 : </p>
                              <p className="font14 add_p">
                                {address2.length == 0 ? "NA" : address2}
                              </p>
                            </div>
                          </div>
                          <div></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <ModalBody>
              <div className="add-btn-wrp add-btn-wrp2">
                <div className="button-div">
                  <Accordion className="main-accordian">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>Device GO</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <GoDeviceOwner id={ownerId} />
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="main-accordian">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>Device 6.0</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <GoDeviceOwnerAcc6 id={ownerId} />
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="main-accordian">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>Device 5.0</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <GodeviceOwnerAccordian5 id={ownerId} />
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </ModalBody>
          </Modal>
          <div className="wrp-bankform">
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                {fetchdata ? (
                  <div className="norecordfound">Fetching record</div>
                ) : (
                  data.length > 0 && (
                    <MaterialTable
                      options={{
                        search: true,
                        showTitle: false,
                        pageSize:
                          data.length <= 5
                            ? 5
                            : data.length > 5 && data.length <= 10
                            ? 10
                            : data.length > 10 && data.length <= 20
                            ? 20
                            : data.length > 20 && data.length <= 30
                            ? 30
                            : data.length > 30 && data.length <= 40
                            ? 40
                            : data.length > 40 && data.length <= 50
                            ? 50
                            : data.length > 50 && data.length <= 100
                            ? 100
                            : 150,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                      }}
                      columns={columns}
                      data={data}
                      title=""
                    />
                  )
                )}

                {fetchdata
                  ? ""
                  : data.length == 0 && (
                      <MaterialTable
                        options={{
                          showTitle: false,
                        }}
                        columns={columns}
                        showTitle={false}
                        pagination={true}
                      />
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerPage;
